import { useApiWithAuth } from "@/modules/api";

interface ClienteRepresentadoPayload {
  idCliente: number;
  nome?: string | null;
  cpfCnpj?: string | null;
  bloqueado?: boolean | null;
  dataCadastro?: Date | null;
}

const useClienteRepresentadoService = () => {
  const { data, loading, get, put } = useApiWithAuth();

  const getRepresentados = (idClienteParceiro: number): Promise<void> => {
    return get(`/root/cliente/${idClienteParceiro}/representados`);
  };

  const updateRepresentados = (
    idClienteParceiro: number,
    representados: Array<ClienteRepresentadoPayload>
  ): Promise<void> => {
    return put(
      `/root/cliente/${idClienteParceiro}/representados`,
      representados.map((r) => ({ idCliente: r.idCliente }))
    );
  };

  return {
    data,
    loading,
    getRepresentados,
    updateRepresentados
  };
};

export { useClienteRepresentadoService, ClienteRepresentadoPayload };
